<div class="page-height-rel">

<div class="oi-main-dshd">

    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="oi-comen-heading bread-mb dc-heading-mb">
                    <div class="row">
                           
                        <div class="col-md-4">
                            <h2>{{documentName}}</h2>
                        </div>
                        <div class="col-md-8 d-flex justify-content-end">
              <div class="search-dcc-mn-t1 d-flex ">
            <div class="kh-hd-searh-t d-flex position-relative kh-srh">
                                <p-autoComplete
                    [(ngModel)]="searchContentText"
                    [suggestions]="filteredDocuments"
                    (completeMethod)="onContentAutoComplete($event)"
                    (onSelect)="openDOcument($event.value)"
                    (keyup.enter)="performDocumentSearch()"
                    field="file_name"
                    placeholder="Search by document name..."
                    [dropdown]="true"
                    >
                    <ng-template let-doc pTemplate="item">
                        <div [innerHTML]="doc.file_name | highlight:searchContentText"></div>
                    </ng-template>
                    </p-autoComplete>

</div>

<div class="kh-hd-searh-t1 d-flex d-none" >        
<input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" />
<button type="button" class="search-dcc-btn" >
                  <svg viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" /><path d="M21 21l-6 -6" /></svg>
</button>
</div>   
              </div> 
          
                            <div class="oi-bread-mn1">
                                <span  class="kh-pointer" (click)="navigateToKh()">Knowledge hub</span> <i class="fa fa-angle-right"></i>
                                <span>{{documentName}}</span>

                            </div>

                        </div>


                    </div>

                </div>
            </div>
            <div class="col-md-12" *ngIf="syncingLoader">
                <div class="doc-upper-loader">
                    <img src="../../assets/img/loader-line.gif" width="150px">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="oi-table1">
                    <div class="table" *ngIf="!loader else loading">
                        <p-table [value]="files" [tableStyle]="{'min-width': '50rem'}" [rows]="10">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th>Document Name</th>
                                    <th>Status</th>
                                    <th>Date</th>
                                    <th>Action</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-file let-columns="columns">
                                <tr>
                                    <td (click)="openDOcument(file)"><span class="docfilename"  [innerHTML]="file.file_name | highlight:searchText"></span></td>
                                    <td>
                                        <div class="oi-dc-status-pb">{{file.status}}</div>
                                    </td>
                                    <td>{{file.updated_at}}</td>
                                    <td class="hover dc-action-icon icon-size">
                                      
                                        <i class="fa fa-eye" aria-hidden="true"  (click)="openDOcument(file)" *ngIf="file.status === 'Published'" pTooltip="view"></i>
                                        <!-- <i class="fa fa-edit" aria-hidden="true" (click)="viewdoc(file, true)" *ngIf="file.status === 'Published'" pTooltip="Edit"></i> -->
                                        <i class="oi-publish-img" *ngIf="file.status != 'Published'" pTooltip="The document is in processeing"><img src="../../assets/img/publish-loader2.gif"></i>
                                        <i class='fa fa-trash' (click)="confirmDelete(file)" *ngIf="file.status === 'Published'" pTooltip="Delete"></i>
                                        <i class="fa fa-bookmark" aria-hidden="true" *ngIf="file.isBookmarked === true" pTooltip="Bookmarked"></i>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                        <div *ngIf="files.length>0">
                            <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
                                [totalRecords]="totalrecords"></p-paginator>
                        </div>
                    </div>
                    <ng-template #loading>
                        <div class="imgloader">
                            <img src="../../assets/img/loader.gif">
                        </div>
                    </ng-template>                 


                    
                </div>
            </div>
        </div>
    </div>
</div>

<p-dialog [(visible)]="showmodal" [header]="selectedfilecontent?.file_name" [style]="{width: '50vw'}" [modal]="true"
    [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false"
    (onHide)="onDialogHideaddcollection()">
    <div class="oi-ad-collect-mdl khdoc">
        <ng-container *ngIf="modalloader else showdata">
            <div class="imgloader">
                <img src="../../assets/img/loader.gif"> 
            </div>
        </ng-container>
        <ng-template #showdata>
            <div class="modal-content documnttext">
                <div *ngIf="isEditMode">

                    <div *ngIf="isPreviewMode">
                        <div [innerHTML]="sanitizeMessage(editableDocument.content)"></div>
                        <div class="col-md-12">
                            <button (click)="togglePreview()" class="btn btn-secondary privew-btn">
                                {{ isPreviewMode ? 'Edit' : 'Preview' }}
                            </button>
                        </div>
                    </div>
                    <form *ngIf="!isPreviewMode" #editForm="ngForm" (ngSubmit)="updateDocument()">
                        <div class="form-group">
                            <md-editor [(ngModel)]="editableDocument.content" name="content" [options]="editorOptions"
                                [mode]="mode" ></md-editor>
                        </div>
                        <div class="oi-document-mdl-submt">
                            <div class="row">

                                <div class="col-md-12">
                                    <button (click)="togglePreview()" class="btn btn-secondary privew-btn">
                                        {{ isPreviewMode ? 'Edit' : 'Preview' }}
                                    </button>
                                    <button type="submit" class="btn btn-primary">Save</button>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
                <div *ngIf="!isEditMode">
                    <div [innerHTML]="sanitizeMessage(selectedfilecontent.content)"></div>
                </div>
            </div>
        </ng-template>
    </div>

</p-dialog>
<app-file-upload-modal
  [(visible)]="showuploadmodal"
  [files]="filearray"
  [uploadLoader]="uploadloader"
  (fileSelected)="handleFileSelection($event)"
  (fileUploaded)="handleFileUpload()"
  (fileDeleted)="handleFileDelete($event)">
</app-file-upload-modal>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="doc-add-new-table-btn">
    <div class="add-new" (click)="uploadDoc($event,documentName)">
        
        <button class="add-plus1"><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg> <span>Add New</span></button>
        
    </div>
    
</div>


</div>